/**
 * ActivityInstructions Component
 *
 * Features:
 * - Displays instructions for the activity, including warnings and important notes.
 * - Uses i18next for translations.
 * - Utilizes Material-UI Button and Icon components for UI.
 * - Handles view change via the changeView prop.
 */
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import InfoIcon from '@mui/icons-material/Info';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import classes from './ActivityInstructions.module.css';

const ActivityInstructions = props => {
  const { t } = useTranslation(['lesson']);
  return (
    <>
      <div className={classes.activityContainer}>
        <aside className={classes.instructionsContainer}>
          <p className={classes.instructions__title}>
            {t('instructions')}:
          </p>
          <p className={classes.instructions__text}>
            {t('activity_text_F')}{' '}
            <strong>“{t('attach_file')}”</strong>{' '}
            {t('activity_text_S')}
          </p>
          <p className={classes.instructions__text}>
            {t('evaluated_by_classmates')}
          </p>
          <InfoIcon className={classes.iconColor} />
          <aside className={classes.warningContainer}>
            <p className={classes.instructions__secondText}>
              <strong>{t('important')}</strong>
            </p>
            <p className={classes.instructions__secondText}>
              {t('activity_text_T')}
            </p>
          </aside>
        </aside>
      </div>
      <aside className={classes.btnsContainer}>
        <Button
          onClick={props.changeView}
          className={classes.nextBtn}
        >
          {t('continue')} <ChevronRightIcon />
        </Button>
      </aside>
    </>
  );
};

ActivityInstructions.propTypes = {
  /**
   * Function to change the view when the button is clicked
   */
  changeView: PropTypes.func
};

ActivityInstructions.defaultProps = {
  changeView: () => {}
};

export default ActivityInstructions;
